import React, { useContext, useEffect, useRef, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import Header from '../Header/Header';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Footer from '../Footer/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, useNavigate } from 'react-router-dom';
import { FaChevronLeft, FaChevronRight, FaRegBookmark } from 'react-icons/fa';
import { WishlistContext } from '../Wishlist/WishlistContext';
import { CartContext } from '../Cart/CartContext';
import { FaArrowRight } from 'react-icons/fa';
import axios from 'axios';
import { FcBookmark } from "react-icons/fc";
import a1 from './fdd2yv2k.png';
import a2 from './sc7dowb7.png';
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import ReactCountryFlag from "react-country-flag";
import { countryCodeMap } from "../countryMap/countryMap";
import './Home.css'


const Home = () => {


    const navigate = useNavigate();


    const { addToWishlist } = useContext(WishlistContext);

    const [user, setUser] = useState(null);
    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);




    const [banners, setBanners] = useState([]);
    useEffect(() => {
        const fetchBanners = async () => {
            try {
                const response = await fetch('https://api.glocart.in/pages/api/api/banners');
                if (response.ok) {
                    const data = await response.json();
                    setBanners(data);
                } else {
                    console.error('Error fetching banners');
                }
            } catch (error) {
                console.error('Failed to fetch banners:', error);
            }
        };

        fetchBanners();
    }, []);


    const trendingRef = useRef(null);

    const trendingRef1 = useRef(null);
    const trendingRefPS = useRef(null);
    const trendingRefB = useRef(null);

    const scroll = (direction, ref) => {
        const container = ref.current;
        if (container) {
            if (direction === 'left') {
                container.scrollLeft -= 300;
            } else {
                container.scrollLeft += 300;
            }
        }
    };
    const scroll1 = (direction, ref) => {
        const container = ref.current;
        if (container) {
            if (direction === 'left') {
                container.scrollLeft -= 300;
            } else {
                container.scrollLeft += 300;
            }
        }
    };

    const [categoriesp, setCategoriesp] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    useEffect(() => {
        fetch('https://api.glocart.in/pages/api/api/categories')
            .then(res => res.json())
            .then(data => setCategoriesp(data))
            .catch(err => console.error('Error fetching categories:', err));
        fetch('https://api.glocart.in/pages/api/api/subcategories')
            .then(res => res.json())
            .then(data => setSubcategories(data))
            .catch(err => console.error('Error fetching subcategories:', err));
    }, []);








    const [selectedVariants, setSelectedVariants] = useState({});
    const [products, setProducts] = useState([]);
    const { cartItems, addToCart, increaseQuantity, decreaseQuantity, removeFromCart } = useContext(CartContext);
    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await fetch('https://api.glocart.in/pages/api/products/get');
                if (response.ok) {
                    const data = await response.json();
                    const shuffled = data.sort(() => 0.5 - Math.random());
                    setProducts(shuffled);
                } else {
                    console.error('Error fetching products');
                }
            } catch (err) {
                console.error('Error fetching product:', err);
            }
        };
        fetchProducts();
    }, []);

    const getQuantity = (productId, variantId) => {
        const item = cartItems.find(item =>
            item.productId === productId && item.variantId === variantId
        );
        return item ? item.quantity : 0;
    };

    const handleAddClick = (product, selectedVariant) => {
        if (!product || !selectedVariant) return;
        if (selectedVariant.stock <= 0) {
            alert('This variant is out of stock!');
            return;
        }
        const discount = selectedVariant.discount || 0;
        const originalPrice = selectedVariant.price;
        const discountedPrice = discount
            ? Math.round(originalPrice - (originalPrice * discount) / 100)
            : originalPrice;
        addToCart({
            productId: product.id,
            variantId: selectedVariant.id,
            name: product.name,
            image: product.image_1,
            price: discountedPrice,
            originalPrice: originalPrice, // ✅ Add originalPrice
            type: product.type || (user?.businessType === 'B2B' ? 'B2B' : 'B2C'),
        }, 1);

        alert(`${product.name} added to cart!`);
    };


    const handleIncrement = (productId, variantId) => {
        const product = products.find(p => p.id === productId);
        const selectedIndex = selectedVariants[productId] ?? 0;
        const selectedVariant = product?.variants?.[selectedIndex];
        const currentQuantity = getQuantity(productId, variantId);
        if (selectedVariant) {
            const maxQty = selectedVariant.stock;
            if (currentQuantity < maxQty) {
                increaseQuantity(productId, variantId);
            } else {
                alert('Enough stock added to cart. No more available!');
            }
        }
    };

    const handleDecrement = (productId, variantId) => {
        // Find the product to get its quantity
        const quantity = getQuantity(productId, variantId);

        if (quantity > 1) {
            decreaseQuantity(productId, variantId);
        } else {
            // If the quantity is 1, remove the item completely from the cart
            const product = products.find(p => p.id === productId);
            const selectedIndex = selectedVariants[productId] ?? 0;
            const selectedVariant = product?.variants?.[selectedIndex];
            if (selectedVariant) {
                removeFromCart(productId, selectedVariant.id);
            }
        }
    };

    const [categories, setCategories] = useState([]);

    useEffect(() => {
        fetch("https://api.glocart.in/pages/api/api/supercategories")
            .then((res) => res.json())
            .then((data) => setCategories(data))
            .catch((err) => console.error("Error fetching data:", err));
    }, []);





    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const isMobile = width < 768;


    // this is varma changes start 

    //============ scroll in cuisions 

    const scrollContainerRef = useRef(null);

    useEffect(() => {
        const el = scrollContainerRef.current;
        if (!el) return;

        let isScrolling = false;

        const onWheel = (e) => {
            if (e.deltaY === 0) return;
            e.preventDefault(); // ✅ stop page scroll

            const scrollSpeed = 3; // 🔥 increase for faster scrolling
            const targetScroll = el.scrollLeft + e.deltaY * scrollSpeed;

            // Smooth animation
            if (!isScrolling) {
                isScrolling = true;
                const start = el.scrollLeft;
                const distance = targetScroll - start;
                const duration = 0; // ms
                const startTime = performance.now();

                const animateScroll = (time) => {
                    const elapsed = time - startTime;
                    const progress = Math.min(elapsed / duration, 1);
                    el.scrollLeft = start + distance * easeOutCubic(progress);
                    if (progress < 1) {
                        requestAnimationFrame(animateScroll);
                    } else {
                        isScrolling = false;
                    }
                };

                requestAnimationFrame(animateScroll);
            }
        };

        // Custom easing function for smoothness
        const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

        el.addEventListener("wheel", onWheel, { passive: false });
        return () => el.removeEventListener("wheel", onWheel);
    }, []);

    //======== cuisine navigate 


    //     const handleCuisine = (name) => {
    //     console.log("Selected cuisine:", name);
    //     // you can navigate, filter, or update state here
    //       navigate(`/food/${name}`)
    //   };
    const handleCuisine = (extraParam) => {

        //navigate(`/food/dummyCat/dummySub/${encodeURIComponent("Indian")}`);


        let path = `/foodCuisines/${encodeURIComponent(extraParam)}`;
        // if (extraParam) {
        //     path += `/${encodeURIComponent(extraParam)}`;
        // }
        navigate(path);
    };



    // const [wishlist, setWishlist] = useState({}); // mapping key -> true
    // useEffect(() => {
    //     const user = JSON.parse(sessionStorage.getItem('userData'));
    //     if (!user?.id) return;
    //     axios
    //         .get(`https://api.glocart.in/pages/api/app/wishlist/${user.id}`)
    //         .then((res) => {
    //             const wishMap = {};
    //             res.data.forEach((item) => {
    //                 const key = `${item.productId}_${item.variantId}`;
    //                 wishMap[key] = true;
    //             });
    //             setWishlist(wishMap);
    //         })
    //         .catch((err) => console.error('Error fetching wishlist:', err));
    // }, []);
    const [wishlist, setWishlist] = useState({}); // mapping key -> true

    useEffect(() => {
        const user = JSON.parse(sessionStorage.getItem('userData'));
        if (!user?.id) return;

        const fetchWishlist = () => {
            axios
                .get(`https://api.glocart.in/pages/api/app/wishlist/${user.id}`)
                .then((res) => {
                    const wishMap = {};
                    res.data.forEach((item) => {
                        const key = `${item.productId}_${item.variantId}`;
                        wishMap[key] = true;
                    });
                    setWishlist(wishMap);
                })
                .catch((err) => console.error('Error fetching wishlist:', err));
        };

        // Initial fetch
        fetchWishlist();

        // Fetch every 1 second
        const intervalId = setInterval(fetchWishlist, 1000);

        // Clean up interval on unmount
        return () => clearInterval(intervalId);
    }, []);

    const handleNavigate = (path) => {
        navigate(path);
    };





    // const itemsPerPage = 5;
    // const itemWidth = 250; // approx card width including gap (can adjust)
    // const pageWidth = itemsPerPage * itemWidth;

    // const totalPages = Math.ceil(categories.length / itemsPerPage);

    // const [activePage, setActivePage] = useState(0);

    // const goToPage = (pageIndex) => {
    //     const container = scrollContainerRef.current;
    //     if (!container) return;

    //     container.scrollTo({
    //         left: pageIndex * pageWidth,
    //         behavior: "smooth",
    //     });

    //     setActivePage(pageIndex);
    // };

    // // Auto-scroll
    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setActivePage((prev) => {
    //             const nextPage = (prev + 1) % totalPages; // loop back
    //             goToPage(nextPage);
    //             return nextPage;
    //         });
    //     }, 2500); // change slide every 2.5 seconds

    //     return () => clearInterval(interval);
    // }, [totalPages]);

    // useEffect(() => {
    //     const container = scrollContainerRef.current;
    //     if (!container) return;

    //     const onScroll = () => {
    //         const newPage = Math.round(container.scrollLeft / pageWidth);
    //         setActivePage(newPage);
    //     };

    //     container.addEventListener("scroll", onScroll);
    //     return () => container.removeEventListener("scroll", onScroll);
    // }, []);
    const itemsPerPage = 5;
    const itemWidth = 300; // approx card + gap width
    const pageWidth = itemsPerPage * itemWidth;

    const totalPages = Math.ceil(categories.length / itemsPerPage);

    const [activePage, setActivePage] = useState(0);
    const [direction, setDirection] = useState(1); // 1 = forward, -1 = backward
    const [isPaused, setIsPaused] = useState(false);

    // useEffect(() => {
    //     if (isPaused) return; // pause auto-scroll on hover

    //     const interval = setInterval(() => {
    //         setActivePage((prevPage) => {
    //             let nextPage = prevPage + direction;

    //             if (nextPage >= totalPages - 1) {
    //                 setDirection(-1);     // reverse direction
    //                 nextPage = totalPages - 1;
    //             }
    //             if (nextPage <= 0) {
    //                 setDirection(1);      // reverse direction
    //                 nextPage = 0;
    //             }

    //             goToPage(nextPage);
    //             return nextPage;
    //         });
    //     }, 2500);

    //     return () => clearInterval(interval);
    // }, [direction, isPaused, totalPages]);


    const goToPage = (pageIndex) => {
        const container = scrollContainerRef.current;
        if (!container) return;

        container.scrollTo({
            left: pageIndex * pageWidth,
            behavior: "smooth",
        });

        setActivePage(pageIndex);
    };
    useEffect(() => {
        const container = scrollContainerRef.current;
        if (!container) return;

        const onScroll = () => {
            const newPage = Math.round(container.scrollLeft / pageWidth);
            setActivePage(newPage);
        };

        container.addEventListener("scroll", onScroll);
        return () => container.removeEventListener("scroll", onScroll);
    }, []);

    const [isAutoScrollEnabled, setIsAutoScrollEnabled] = useState(true);

    useEffect(() => {
        const updateAutoScroll = () => {
            const width = window.innerWidth;

            // Disable auto-scroll on tablet & mobile
            if (width <= 1024) {
                setIsAutoScrollEnabled(false);
            } else {
                setIsAutoScrollEnabled(true);
            }
        };

        updateAutoScroll();
        window.addEventListener("resize", updateAutoScroll);

        return () => window.removeEventListener("resize", updateAutoScroll);
    }, []);

    useEffect(() => {
        if (!isAutoScrollEnabled || isPaused) return; // STOP on mobile/tablet

        const interval = setInterval(() => {
            setActivePage((prevPage) => {
                let nextPage = prevPage + direction;

                if (nextPage >= totalPages - 1) {
                    setDirection(-1);
                    nextPage = totalPages - 1;
                }
                if (nextPage <= 0) {
                    setDirection(1);
                    nextPage = 0;
                }

                goToPage(nextPage);
                return nextPage;
            });
        }, 2500);

        return () => clearInterval(interval);
    }, [direction, isPaused, totalPages, isAutoScrollEnabled]);

    return (
        <>
            <Header />

            <>

                <div
                    style={{
                        // backgroundColor: "#f6d46b",
                        // background: "linear-gradient(180deg, #eae0cc 0%, #f3e3bf 50%, #ecd7a6 100%)",
                        background: "linear-gradient(180deg, #F8EEDB 0%, #F3DFAF 100%)",
                        padding: "25px",
                        overflow: "hidden",
                        zIndex: 2,
                        position: "relative",
                        color: "white", boxShadow: "inset 0px 16px 12px rgba(0,0,0,0.20)",


                    }}
                >
                    {/* <div
                        style={{
                            backgroundColor: 'lightblue',
                            padding: '8px 20px',
                            borderRadius: '25px',
                            width: 'fit-content',
                            margin: '20px auto',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                            fontWeight: 'bold',
                            // cursor: 'pointer',
                            color:'black'
                        }}
                    >
                        Shop By
                    </div> */}

                    <h3 style={{ textAlign: "center", marginBottom: "10px", color: 'black' }}>CUISINES</h3>

                    <div
                        ref={scrollContainerRef}
                        onMouseEnter={() => setIsPaused(true)}
                        onMouseLeave={() => setIsPaused(false)}
                        style={{
                            display: "flex",
                            gap: "20px",
                            padding: "10px",
                            width: "100%",
                            margin: "0 auto",
                            scrollBehavior: "smooth",
                            overflowX: "auto",
                            overflowY: "hidden",
                            flexWrap: "nowrap",            // added
                            //scrollSnapType: "x mandatory", // added
                            // scrollbarWidth: "none",
                            // msOverflowStyle: "none",
                        }}
                    >
                        <style>
                            {`
                div::-webkit-scrollbar {
                    display: none;
                }

                /* 📌 Tablet (max-width: 992px) → 3 items */
                @media (max-width: 992px) {
                    .cuisine-card {
                        flex: 0 0 calc(33.33% - 15px) !important;
                    }
                }

                /* 📌 Mobile (max-width: 768px) → 2 items */
                @media (max-width: 768px) {
                    .cuisine-card {
                        flex: 0 0 calc(50% - 15px) !important;
                    }
                }

                /* 📌 Small Mobile (max-width: 480px) → 1 large item */
                @media (max-width: 480px) {
                    .cuisine-card {
                        flex: 0 0 80% !important;
                    }
                }
            `}
                        </style>

                        {categories.map((item) => (
                            <div
                                key={item.id}
                                className="cuisine-card"
                                style={{
                                    flex: "0 0 calc(20% - 15px)",
                                    textAlign: "center",
                                    scrollSnapAlign: "start",

                                }}
                                onMouseEnter={(e) => {
                                    if (window.innerWidth <= 1024) return;
                                }}
                                onMouseLeave={(e) => {
                                    if (window.innerWidth <= 1024) return;
                                }}
                            >
                                {/* // <div
                            //     key={item.id}
                            //     className="cuisine-card"
                            //     style={{
                            //         flex: "0 0 calc(20% - 15px)",
                            //         textAlign: "center",
                            //         transition: "transform 0.4s ease, box-shadow 0.4s ease",
                            //         cursor: "pointer",
                            //     }}
                                // onMouseEnter={(e) => {
                                //     e.currentTarget.style.transform = "perspective(600px) rotateX(6deg) rotateY(6deg) scale(1.08)";
                                //     e.currentTarget.style.boxShadow = "0 15px 25px rgba(0,0,0,0.3)";
                                // }}
                                // onMouseLeave={(e) => {
                                //     e.currentTarget.style.transform = "perspective(600px) rotateX(0deg) rotateY(0deg) scale(1)";
                                //     e.currentTarget.style.boxShadow = "0 0 0 rgba(0,0,0,0)";
                                // }}
                            // > */}

                                <div
                                    onClick={() => handleCuisine(item.name)}
                                    style={{
                                        width: "65%",
                                        aspectRatio: "1/1",
                                        borderRadius: "65%",
                                        overflow: "hidden",
                                        margin: "0 auto 0px",
                                        cursor: "pointer",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                                    }}
                                    onMouseEnter={(e) => {

                                        e.currentTarget.style.transform = "perspective(600px) rotateX(6deg) rotateY(6deg) scale(1.08)";
                                        e.currentTarget.style.boxShadow = "0 15px 25px rgba(0,0,0,0.3)";
                                    }}
                                    onMouseLeave={(e) => {

                                        e.currentTarget.style.transform = "perspective(600px) rotateX(0deg) rotateY(0deg) scale(1)";
                                        e.currentTarget.style.boxShadow = "0 0 0 rgba(0,0,0,0)";
                                    }}
                                >
                                    <img
                                           src={item.icon}
                                        alt={item.name}
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "contain",
                                        }}
                                    />
                                </div>

                                <div style={{ fontWeight: "bold", marginBottom: "4px", color: 'black' }}>
                                    {item.name}
                                </div>

                                <div
                                    style={{
                                        textDecoration: "none",
                                        color: "#000000ff",
                                        cursor: "pointer",
                                        opacity: 0.8,

                                    }}
                                    onClick={() => handleCuisine(item.name)}
                                >
                                    <span style={{ fontSize: '12px', color: 'black' }}> View Collection </span> <IoArrowForwardCircleOutline />
                                </div>
                            </div>
                        ))}


                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "15px",
                            gap: "8px",
                        }}
                    >
                        {Array.from({ length: totalPages }).map((_, index) => (
                            <div
                                key={index}
                                onClick={() => goToPage(index)}
                                style={{
                                    width: activePage === index ? 14 : 10,
                                    height: activePage === index ? 14 : 10,
                                    borderRadius: "50%",
                                    backgroundColor: activePage === index ? "#fff" : "rgba(255,255,255,0.5)",
                                    cursor: "pointer",
                                    transition: "0.3s",
                                }}
                            ></div>
                        ))}
                    </div>

                </div>


            </>
            <>
                {/* <div className='mt-5' style={{ width: '1200px', margin: '0 auto', padding: '0 15px' }}>
                    <Carousel autoPlay infiniteLoop showThumbs={false}>
                        {banners.map((banner, index) => (
                            <div key={index}>
                                <img src={banner.image_url} alt={`Slide ${index + 1}`} style={{ height:'350px',borderRadius: '20px',objectFit:'cover' }} />
                            </div>
                        ))}
                    </Carousel>
                </div> */}
                <div className='mt-5' style={{ width: '100%', margin: '0 auto', padding: '0 15px' }}>
                    <Carousel autoPlay infiniteLoop showThumbs={false}>
                        {banners.map((banner, index) => (
                            <div key={index}>
                                <img
                                    src={banner.image_url}
                                    alt={`Slide ${index + 1}`}
                                    style={{
                                        width: '100%',
                                        height: 'auto', // maintain aspect ratio
                                        maxHeight: '500px',
                                        borderRadius: '20px',
                                        objectFit: 'cover',
                                    }}
                                />
                                {/* <button
                                    onClick={() => navigate('/category')}
                                    style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '20px',
                                        transform: 'translateY(-50%)',
                                        backgroundColor: '#0357a0',
                                        color: '#fff',
                                        border: 'none',
                                        padding: '10px 20px',
                                        borderRadius: '10px',
                                        cursor: 'pointer',
                                        fontSize: '1rem',
                                        whiteSpace: 'nowrap',
                                        zIndex: 2,
                                    }}
                                >
                                    Shop Now
                                </button> */}
                                <button
                                    className="banner-button"
                                    onClick={() => navigate('/category')}
                                >
                                    Shop Now
                                </button>
                            </div>
                        ))}
                    </Carousel>
                </div>

            </>

            <div className="mt-2" style={{ margin: '0 auto', padding: "20px 30px", backgroundColor: '#f3f2f2', borderRadius: '20px' }}>
                {/* Header with Scroll Buttons */}

                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="fw-bold mb-0"> <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px 0' }}>
                        <h6 style={{ color: '#333', textTransform: 'uppercase', margin: 0 }}><strong>  <Link to={`/categories/Pantry%20Staples`} style={{ textDecoration: 'none', color: "black" }}> Pantry Staples  </Link> </strong></h6>

                        {/* // <Link to={`/categories/Pantry%20Staples`} style={{ textDecoration: 'none', color: '#007bff', fontWeight: '600', fontSize: '14px' }}>
                            //     View More
                            // </Link> */}

                    </div></h6>

                    <div className="d-flex align-items-center gap-2">
                        <Link to="/category" className="text-decoration-none me-2 text-black">View All</Link>
                        <button className="btn btn-light shadow-sm" onClick={() => scroll('left', trendingRefPS)}><FaChevronLeft /></button>
                        <button className="btn btn-light shadow-sm" onClick={() => scroll('right', trendingRefPS)}><FaChevronRight /></button>
                    </div>
                </div>

                {/* Product Cards */}
                {products.length === 0 ? (
                    <div className="text-center text-muted"><p>No products available</p></div>
                ) : (
                    <div ref={trendingRefPS} className="d-flex" style={{ gap: '1rem', paddingBottom: '1rem', scrollBehavior: 'smooth', overflowX: 'auto', overflowY: 'hidden', msOverflowStyle: 'none', scrollbarWidth: 'none', }} >
                        {products
                            .filter((item) =>
                                item.category?.trim().toLowerCase() === "pantry staples"
                            )
                            .filter((product) => {
                                if (!user) return true;
                                if (user.businessType === 'B2B') return product.bb;
                                if (user.businessType === 'B2C') return product.bc;
                                return true;
                            })
                            .map((product) => {
                                const selectedIndex = selectedVariants[product.id] ?? 0;
                                const selectedVariant = product.variants?.[selectedIndex];
                                const currentQuantity = selectedVariant ? getQuantity(product.id, selectedVariant.id) : 0;
                                const maxDiscountVariant = product.variants?.reduce((max, variant) => variant.discount > max.discount ? variant : max, product.variants[0]);
                                const discountedPrice = selectedVariant?.discount
                                    ? Math.round(selectedVariant.price - (selectedVariant.price * selectedVariant.discount) / 100)
                                    : null;


                                const key = `${product.id}_${selectedVariant?.id}`;
                                const isWishlisted = wishlist[key];
                                return (
                                    <div key={product.id} className="border bg-white shadow-sm flex-shrink-0 d-flex flex-column position-relative" style={{ width: '250px', height: '400px', borderRadius: '12px', overflow: 'hidden', }}>
                                        {/* Discount Badge */}
                                        {maxDiscountVariant?.discount > 0 && (
                                            <div className="position-absolute top-0 start-0 m-2 badge" style={{ background: "linear-gradient(180deg, #F8EEDB 0%, #F3DFAF 100%)", fontSize: '0.75rem', color: '#0058A2' }}>
                                                {maxDiscountVariant.discount}% OFF
                                            </div>
                                        )}

                                        {/* Product Image */}
                                        <div className="mx-3 mt-3 mb-1 p-2" style={{ border: '1px solid #eee', borderRadius: '8px', backgroundColor: '#fff', }}>
                                            <Link to={`/product/${product.id}`}>
                                                <img src={product.image_1} alt={product.name} className="card-img-top" style={{ height: '140px', width: '100%', objectFit: 'contain', }} />
                                            </Link>
                                        </div>

                                        {/* Card Content */}
                                        <div className="card-body d-flex flex-column px-3 py-1">
                                            <p style={{ fontSize: 11, color: '#000000', marginBottom: 4, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                <ReactCountryFlag
                                                    countryCode={countryCodeMap[product.super_category]}
                                                    svg
                                                    style={{ width: '18px', height: '18px' }}
                                                />
                                                {product.super_category}
                                            </p>
                                            <p style={{ fontSize: '11px', color: '#4caf50', marginBottom: "2px" }}>⚡ {product.category}</p>
                                            {/* <p style={{ fontSize: 11, color: '#4caf50', marginBottom: 4 }}>
                                                {product.super_category}
                                            </p> */}

                                            <p className="text-muted mb-1" style={{ fontSize: '0.8rem', }}>{product.brand}!</p>
                                            <h6 className="fw-bold mb-2" style={{ fontSize: '0.95rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{product.name}</h6>

                                            {/* Variant Selection */}
                                            <div className="mb-2" style={{ position: 'relative' }}>
                                                <div style={{ border: '1px solid #ccc', padding: '4px 6px', backgroundColor: '#fff', cursor: 'pointer', fontSize: '13px', }}
                                                    onClick={() => setSelectedVariants(prev => ({ ...prev, [product.id + '_open']: !prev[product.id + '_open'], }))}>
                                                    {selectedVariant && (
                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                            <div>
                                                                <strong>{selectedVariant.unit_value} {selectedVariant.unit}</strong>{' '}
                                                                {selectedVariant.discount > 0 && (
                                                                    <span style={{ color: 'green', fontWeight: 'bold' }}>{selectedVariant.discount}% OFF</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                {selectedVariants[product.id + '_open'] && (
                                                    <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #ccc', zIndex: 1000, marginTop: '4px', maxHeight: '200px', overflowY: 'auto' }}>
                                                        {product.variants.map((variant, index) => {
                                                            const variantDiscountedPrice = variant.price - (variant.price * variant.discount) / 100;
                                                            return (
                                                                <div key={index} onClick={() => { setSelectedVariants(prev => ({ ...prev, [product.id]: index, [product.id + '_open']: false })); }}
                                                                    style={{ padding: '8px', borderBottom: '1px solid #eee', backgroundColor: selectedVariants[product.id] === index ? '#f6f6f6' : 'white', cursor: 'pointer', fontSize: '10px' }}>
                                                                    <div>
                                                                        <strong>{variant.unit_value} {variant.unit}</strong>{' '}
                                                                        {variant.discount > 0 && (<span style={{ color: 'green', fontWeight: 'bold' }}>{variant.discount}% OFF</span>)}
                                                                    </div>
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '2px' }}>
                                                                        <span style={{ fontWeight: 'bold' }}>₹{Math.round(variantDiscountedPrice)}</span>
                                                                        {variant.discount > 0 && (<span style={{ textDecoration: 'line-through', color: '#999' }}>₹{variant.price}</span>)}
                                                                        <span style={{ fontSize: '10px', backgroundColor: '#e0f7e9', color: '#4caf50', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>⚡ ADD</span>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>

                                            {/* Price Display */}
                                            <div className="mb-2">
                                                {selectedVariant ? (
                                                    <>
                                                        {discountedPrice !== null ? (
                                                            <>
                                                                <span className="fw-bold text-dark">₹{discountedPrice}</span>{' '}
                                                                <span className="text-muted text-decoration-line-through me-2">₹{selectedVariant.price}</span>
                                                            </>
                                                        ) : (
                                                            <span className="fw-bold">₹{selectedVariant.price}</span>
                                                        )}
                                                    </>
                                                ) : (
                                                    <span className="fw-bold">₹0</span>
                                                )}
                                            </div>

                                            {/* Add/Quantity Controls */}
                                            <div className="d-flex align-items-center mt-auto" style={{ gap: '8px' }}>

                                                <button style={{ border: '1px solid #ccc', background: '#fff', borderRadius: '6px', padding: '8px', fontSize: '16px', cursor: 'pointer' }}
                                                    onClick={() => {
                                                        addToWishlist(product, selectedVariant);
                                                        // alert(`${product.name} saved to wishlist!`);
                                                        alert(
                                                            isWishlisted
                                                                ? `${product.name} removed from wishlist!`
                                                                : `${product.name} saved to wishlist!`
                                                        );
                                                    }}>
                                                    {/* <FaRegBookmark style={{color:'black'}}/> */}
                                                    {/* <FaRegBookmark
                                                            style={{
                                                                color: isWishlisted ? 'red' : 'black',       // change icon color when saved
                                                                fill: isWishlisted ? 'red' : 'green'          // fill icon when saved
                                                            }}
                                                        /> */}
                                                    {isWishlisted ? (
                                                        <FcBookmark size={22} />     // filled icon
                                                    ) : (
                                                        <FaRegBookmark size={22} />   // empty icon
                                                    )}
                                                </button>

                                                {currentQuantity > 0 ? (
                                                    <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #0057A0', borderRadius: 6, overflow: 'hidden' }}>
                                                        <button style={{ background: '#0057A0', color: '#fff', padding: '6px 30px', border: 'none' }} onClick={() => handleDecrement(product.id, selectedVariant.id)}>−</button>
                                                        <div style={{ padding: '6px 12px', fontSize: 14 }}>
                                                            {currentQuantity}
                                                        </div>
                                                        <button style={{ background: '#0057A0', color: '#fff', padding: '6px 35px', border: 'none' }} onClick={() => handleIncrement(product.id, selectedVariant.id)}>+</button>
                                                    </div>
                                                ) : (
                                                    <button style={{ padding: '6px 70px', border: '1px solid #0057A0', borderRadius: 6, background: '#fff', color: '#0057A0' }} onClick={() => handleAddClick(product, selectedVariant)} >Add</button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                )}
            </div>



            {/* <div className="py-5 mt-3" style={{ maxWidth: '1200px', margin: '0 auto', padding: "20px 30px", backgroundColor: '#f3f2f27c', borderRadius: '20px' }}>
               
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="fw-bold mb-0">Bakery & Desserts</h6>
                  
                </div>

                <div className='mt-5' style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 15px' }}>
                    <img
                        onClick={() => handleNavigate("/categories/Bakery%20%26%20Desserts")}
                        src={a2}
                        alt="Banner"
                        style={{
                            borderRadius: '20px',
                            objectFit: 'contain',
                            width: '100%',
                            height: 'auto'
                        }}
                    />

                </div>

            </div> */}


            <div className="mt-2" style={{ margin: '0 auto', padding: "20px 30px", backgroundColor: '#f3f2f2', borderRadius: '20px' }}>
                {/* Header with Scroll Buttons */}

                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="fw-bold mb-0" >   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px 0' }}>
                        <h6 style={{ color: '#333', textTransform: 'uppercase', margin: 0 }}><strong>  <Link to={`/categories/Bakery%20%26%20Desserts`} style={{ textDecoration: 'none', color: 'black' }}>Bakery & Desserts </Link></strong></h6>
                    </div></h6>
                    <div className="d-flex align-items-center gap-2">
                        <Link to="/category" className="text-decoration-none me-2 text-black">View All</Link>
                        <button className="btn btn-light shadow-sm" onClick={() => scroll('left', trendingRefB)}><FaChevronLeft /></button>
                        <button className="btn btn-light shadow-sm" onClick={() => scroll('right', trendingRefB)}><FaChevronRight /></button>
                    </div>
                </div>

                {/* Product Cards */}
                {products.length === 0 ? (
                    <div className="text-center text-muted"><p>No products available</p></div>
                ) : (
                    <div ref={trendingRefB} className="d-flex" style={{ gap: '1rem', paddingBottom: '1rem', scrollBehavior: 'smooth', overflowX: 'auto', overflowY: 'hidden', msOverflowStyle: 'none', scrollbarWidth: 'none', }} >
                        {products
                            .filter((item) =>
                                item.category?.trim().toLowerCase() === "bakery & desserts"
                            )
                            .filter((product) => {
                                if (!user) return true;
                                if (user.businessType === 'B2B') return product.bb;
                                if (user.businessType === 'B2C') return product.bc;
                                return true;
                            })
                            .map((product) => {
                                const selectedIndex = selectedVariants[product.id] ?? 0;
                                const selectedVariant = product.variants?.[selectedIndex];
                                const currentQuantity = selectedVariant ? getQuantity(product.id, selectedVariant.id) : 0;
                                const maxDiscountVariant = product.variants?.reduce((max, variant) => variant.discount > max.discount ? variant : max, product.variants[0]);
                                const discountedPrice = selectedVariant?.discount
                                    ? Math.round(selectedVariant.price - (selectedVariant.price * selectedVariant.discount) / 100)
                                    : null;


                                const key = `${product.id}_${selectedVariant?.id}`;
                                const isWishlisted = wishlist[key];
                                return (
                                    <div key={product.id} className="border bg-white shadow-sm flex-shrink-0 d-flex flex-column position-relative" style={{ width: '250px', height: '400px', borderRadius: '12px', overflow: 'hidden', }}>
                                        {/* Discount Badge */}
                                        {maxDiscountVariant?.discount > 0 && (
                                            <div className="position-absolute top-0 start-0 m-2 badge" style={{ background: "linear-gradient(180deg, #F8EEDB 0%, #F3DFAF 100%)", fontSize: '0.75rem', color: '#0058A2' }}>
                                                {maxDiscountVariant.discount}% OFF
                                            </div>
                                        )}

                                        {/* Product Image */}
                                        <div className="mx-3 mt-3 mb-1 p-2" style={{ border: '1px solid #eee', borderRadius: '8px', backgroundColor: '#fff', }}>
                                            <Link to={`/product/${product.id}`}>
                                                <img src={product.image_1} alt={product.name} className="card-img-top" style={{ height: '140px', width: '100%', objectFit: 'contain', }} />
                                            </Link>
                                        </div>

                                        {/* Card Content */}
                                        <div className="card-body d-flex flex-column px-3 py-1">
                                            <p style={{ fontSize: 11, color: '#000000', marginBottom: 4, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                <ReactCountryFlag
                                                    countryCode={countryCodeMap[product.super_category]}
                                                    svg
                                                    style={{ width: '18px', height: '18px' }}
                                                />
                                                {product.super_category}
                                            </p>
                                            <p style={{ fontSize: '11px', color: '#4caf50', marginBottom: "2px" }}>⚡ {product.category}</p>
                                            <p className="text-muted mb-1" style={{ fontSize: '0.8rem', }}>{product.brand}!</p>
                                            <h6 className="fw-bold mb-2" style={{ fontSize: '0.95rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{product.name}</h6>

                                            {/* Variant Selection */}
                                            <div className="mb-2" style={{ position: 'relative' }}>
                                                <div style={{ border: '1px solid #ccc', padding: '4px 6px', backgroundColor: '#fff', cursor: 'pointer', fontSize: '13px', }}
                                                    onClick={() => setSelectedVariants(prev => ({ ...prev, [product.id + '_open']: !prev[product.id + '_open'], }))}>
                                                    {selectedVariant && (
                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                            <div>
                                                                <strong>{selectedVariant.unit_value} {selectedVariant.unit}</strong>{' '}
                                                                {selectedVariant.discount > 0 && (
                                                                    <span style={{ color: 'green', fontWeight: 'bold' }}>{selectedVariant.discount}% OFF</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                {selectedVariants[product.id + '_open'] && (
                                                    <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #ccc', zIndex: 1000, marginTop: '4px', maxHeight: '200px', overflowY: 'auto' }}>
                                                        {product.variants.map((variant, index) => {
                                                            const variantDiscountedPrice = variant.price - (variant.price * variant.discount) / 100;
                                                            return (
                                                                <div key={index} onClick={() => { setSelectedVariants(prev => ({ ...prev, [product.id]: index, [product.id + '_open']: false })); }}
                                                                    style={{ padding: '8px', borderBottom: '1px solid #eee', backgroundColor: selectedVariants[product.id] === index ? '#f6f6f6' : 'white', cursor: 'pointer', fontSize: '10px' }}>
                                                                    <div>
                                                                        <strong>{variant.unit_value} {variant.unit}</strong>{' '}
                                                                        {variant.discount > 0 && (<span style={{ color: 'green', fontWeight: 'bold' }}>{variant.discount}% OFF</span>)}
                                                                    </div>
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '2px' }}>
                                                                        <span style={{ fontWeight: 'bold' }}>₹{Math.round(variantDiscountedPrice)}</span>
                                                                        {variant.discount > 0 && (<span style={{ textDecoration: 'line-through', color: '#999' }}>₹{variant.price}</span>)}
                                                                        <span style={{ fontSize: '10px', backgroundColor: '#e0f7e9', color: '#4caf50', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>⚡ ADD</span>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>

                                            {/* Price Display */}
                                            <div className="mb-2">
                                                {selectedVariant ? (
                                                    <>
                                                        {discountedPrice !== null ? (
                                                            <>
                                                                <span className="fw-bold text-dark">₹{discountedPrice}</span>{' '}
                                                                <span className="text-muted text-decoration-line-through me-2">₹{selectedVariant.price}</span>
                                                            </>
                                                        ) : (
                                                            <span className="fw-bold">₹{selectedVariant.price}</span>
                                                        )}
                                                    </>
                                                ) : (
                                                    <span className="fw-bold">₹0</span>
                                                )}
                                            </div>

                                            {/* Add/Quantity Controls */}
                                            <div className="d-flex align-items-center mt-auto" style={{ gap: '8px' }}>

                                                <button style={{ border: '1px solid #ccc', background: '#fff', borderRadius: '6px', padding: '8px', fontSize: '16px', cursor: 'pointer' }}
                                                    onClick={() => {
                                                        addToWishlist(product, selectedVariant);
                                                        // alert(`${product.name} saved to wishlist!`);
                                                        alert(
                                                            isWishlisted
                                                                ? `${product.name} removed from wishlist!`
                                                                : `${product.name} saved to wishlist!`
                                                        );
                                                    }}>
                                                    {/* <FaRegBookmark style={{color:'black'}}/> */}
                                                    {/* <FaRegBookmark
                                                            style={{
                                                                color: isWishlisted ? 'red' : 'black',       // change icon color when saved
                                                                fill: isWishlisted ? 'red' : 'green'          // fill icon when saved
                                                            }}
                                                        /> */}
                                                    {isWishlisted ? (
                                                        <FcBookmark size={22} />     // filled icon
                                                    ) : (
                                                        <FaRegBookmark size={22} />   // empty icon
                                                    )}
                                                </button>

                                                {currentQuantity > 0 ? (
                                                    <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #0057A0', borderRadius: 6, overflow: 'hidden' }}>
                                                        <button style={{ background: '#0057A0', color: '#fff', padding: '6px 30px', border: 'none' }} onClick={() => handleDecrement(product.id, selectedVariant.id)}>−</button>
                                                        <div style={{ padding: '6px 12px', fontSize: 14 }}>
                                                            {currentQuantity}
                                                        </div>
                                                        <button style={{ background: '#0057A0', color: '#fff', padding: '6px 35px', border: 'none' }} onClick={() => handleIncrement(product.id, selectedVariant.id)}>+</button>
                                                    </div>
                                                ) : (
                                                    <button style={{ padding: '6px 70px', border: '1px solid #0057A0', borderRadius: 6, background: '#fff', color: '#0057A0' }} onClick={() => handleAddClick(product, selectedVariant)} >Add</button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                )}
            </div>

            <>
                <div className="mt-2" style={{ margin: '0 auto', padding: "20px 30px", backgroundColor: '#f3f2f2', borderRadius: '20px' }}>
                    {/* Header with Scroll Buttons */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="fw-bold mb-0">NEW IN STORE</h6>
                        <div className="d-flex align-items-center gap-2">
                            <Link to="/category" className="text-decoration-none me-2 text-black">View All</Link>
                            <button className="btn btn-light shadow-sm" onClick={() => scroll1('left', trendingRef1)}><FaChevronLeft /></button>
                            <button className="btn btn-light shadow-sm" onClick={() => scroll1('right', trendingRef1)}><FaChevronRight /></button>
                        </div>
                    </div>

                    {/* Product Cards */}
                    {products.length === 0 ? (
                        <div className="text-center text-muted"><p>No products available</p></div>
                    ) : (
                        <div ref={trendingRef1} className="d-flex" style={{ gap: '1rem', paddingBottom: '1rem', scrollBehavior: 'smooth', overflowX: 'auto', overflowY: 'hidden', msOverflowStyle: 'none', scrollbarWidth: 'none', }} >
                            {products
                                .filter((product) => {
                                    // if (!user) return true;
                                    // if (user.businessType === 'B2B') return product.bb;
                                    // if (user.businessType === 'B2C') return product.bc;
                                    if (user) {
                                        if (user.businessType === 'B2B' && !product.bb) return false;
                                        if (user.businessType === 'B2C' && !product.bc) return false;
                                    }

                                    // return true;
                                    // ============================
                                    // 2. FILTER PRODUCTS WITHIN LAST 1 MONTH
                                    // ============================
                                    const oneMonthAgo = new Date();
                                    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

                                    const productDate = new Date(product.created_at); // adjust field if needed

                                    return productDate >= oneMonthAgo;
                                })
                                .map((product) => {
                                    const selectedIndex = selectedVariants[product.id] ?? 0;
                                    const selectedVariant = product.variants?.[selectedIndex];
                                    const currentQuantity = selectedVariant ? getQuantity(product.id, selectedVariant.id) : 0;
                                    const maxDiscountVariant = product.variants?.reduce((max, variant) => variant.discount > max.discount ? variant : max, product.variants[0]);
                                    const discountedPrice = selectedVariant?.discount
                                        ? Math.round(selectedVariant.price - (selectedVariant.price * selectedVariant.discount) / 100)
                                        : null;


                                    const key = `${product.id}_${selectedVariant?.id}`;
                                    const isWishlisted = wishlist[key];
                                    return (
                                        <div key={product.id} className="border bg-white shadow-sm flex-shrink-0 d-flex flex-column position-relative" style={{ width: '250px', height: '400px', borderRadius: '12px', overflow: 'hidden', }}>
                                            {/* Discount Badge */}
                                            {maxDiscountVariant?.discount > 0 && (
                                                <div className="position-absolute top-0 start-0 m-2 badge" style={{ background: "linear-gradient(180deg, #F8EEDB 0%, #F3DFAF 100%)", fontSize: '0.75rem', color: '#0058A2' }}>
                                                    {maxDiscountVariant.discount}% OFF
                                                </div>
                                            )}

                                            {/* Product Image */}
                                            <div className="mx-3 mt-3 mb-1 p-2" style={{ border: '1px solid #eee', borderRadius: '8px', backgroundColor: '#fff', }}>
                                                <Link to={`/product/${product.id}`}>
                                                    <img src={product.image_1} alt={product.name} className="card-img-top" style={{ height: '140px', width: '100%', objectFit: 'contain', }} />
                                                </Link>
                                            </div>

                                            {/* Card Content */}
                                            <div className="card-body d-flex flex-column px-3 py-1">
                                                <p style={{ fontSize: 11, color: '#000000', marginBottom: 4, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    <ReactCountryFlag
                                                        countryCode={countryCodeMap[product.super_category]}
                                                        svg
                                                        style={{ width: '18px', height: '18px' }}
                                                    />
                                                    {product.super_category}
                                                </p>
                                                <p style={{ fontSize: '11px', color: '#4caf50', marginBottom: "2px" }}>⚡ {product.category}</p>
                                                <p className="text-muted mb-1" style={{ fontSize: '0.8rem', }}>{product.brand}!</p>
                                                <h6 className="fw-bold mb-2" style={{ fontSize: '0.95rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{product.name}</h6>

                                                {/* Variant Selection */}
                                                <div className="mb-2" style={{ position: 'relative' }}>
                                                    <div style={{ border: '1px solid #ccc', padding: '4px 6px', backgroundColor: '#fff', cursor: 'pointer', fontSize: '13px', }}
                                                        onClick={() => setSelectedVariants(prev => ({ ...prev, [product.id + '_open']: !prev[product.id + '_open'], }))}>
                                                        {selectedVariant && (
                                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                <div>
                                                                    <strong>{selectedVariant.unit_value} {selectedVariant.unit}</strong>{' '}
                                                                    {selectedVariant.discount > 0 && (
                                                                        <span style={{ color: 'green', fontWeight: 'bold' }}>{selectedVariant.discount}% OFF</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {selectedVariants[product.id + '_open'] && (
                                                        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #ccc', zIndex: 1000, marginTop: '4px', maxHeight: '200px', overflowY: 'auto' }}>
                                                            {product.variants.map((variant, index) => {
                                                                const variantDiscountedPrice = variant.price - (variant.price * variant.discount) / 100;
                                                                return (
                                                                    <div key={index} onClick={() => { setSelectedVariants(prev => ({ ...prev, [product.id]: index, [product.id + '_open']: false })); }}
                                                                        style={{ padding: '8px', borderBottom: '1px solid #eee', backgroundColor: selectedVariants[product.id] === index ? '#f6f6f6' : 'white', cursor: 'pointer', fontSize: '10px' }}>
                                                                        <div>
                                                                            <strong>{variant.unit_value} {variant.unit}</strong>{' '}
                                                                            {variant.discount > 0 && (<span style={{ color: 'green', fontWeight: 'bold' }}>{variant.discount}% OFF</span>)}
                                                                        </div>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '2px' }}>
                                                                            <span style={{ fontWeight: 'bold' }}>₹{Math.round(variantDiscountedPrice)}</span>
                                                                            {variant.discount > 0 && (<span style={{ textDecoration: 'line-through', color: '#999' }}>₹{variant.price}</span>)}
                                                                            <span style={{ fontSize: '10px', backgroundColor: '#e0f7e9', color: '#4caf50', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>⚡ ADD</span>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Price Display */}
                                                <div className="mb-2">
                                                    {selectedVariant ? (
                                                        <>
                                                            {discountedPrice !== null ? (
                                                                <>
                                                                    <span className="fw-bold text-dark">₹{discountedPrice}</span>{' '}
                                                                    <span className="text-muted text-decoration-line-through me-2">₹{selectedVariant.price}</span>
                                                                </>
                                                            ) : (
                                                                <span className="fw-bold">₹{selectedVariant.price}</span>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <span className="fw-bold">₹0</span>
                                                    )}
                                                </div>

                                                {/* Add/Quantity Controls */}
                                                <div className="d-flex align-items-center mt-auto" style={{ gap: '8px' }}>

                                                    <button style={{ border: '1px solid #ccc', background: '#fff', borderRadius: '6px', padding: '8px', fontSize: '16px', cursor: 'pointer' }}
                                                        onClick={() => {
                                                            addToWishlist(product, selectedVariant);
                                                            // alert(`${product.name} saved to wishlist!`);
                                                            alert(
                                                                isWishlisted
                                                                    ? `${product.name} removed from wishlist!`
                                                                    : `${product.name} saved to wishlist!`
                                                            );
                                                        }}>
                                                        {/* <FaRegBookmark style={{color:'black'}}/> */}
                                                        {/* <FaRegBookmark
                                                            style={{
                                                                color: isWishlisted ? 'red' : 'black',       // change icon color when saved
                                                                fill: isWishlisted ? 'red' : 'green'          // fill icon when saved
                                                            }}
                                                        /> */}
                                                        {isWishlisted ? (
                                                            <FcBookmark size={22} />     // filled icon
                                                        ) : (
                                                            <FaRegBookmark size={22} />   // empty icon
                                                        )}
                                                    </button>

                                                    {currentQuantity > 0 ? (
                                                        <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #0057A0', borderRadius: 6, overflow: 'hidden' }}>
                                                            <button style={{ background: '#0057A0', color: '#fff', padding: '6px 30px', border: 'none' }} onClick={() => handleDecrement(product.id, selectedVariant.id)}>−</button>
                                                            <div style={{ padding: '6px 12px', fontSize: 14 }}>
                                                                {currentQuantity}
                                                            </div>
                                                            <button style={{ background: '#0057A0', color: '#fff', padding: '6px 35px', border: 'none' }} onClick={() => handleIncrement(product.id, selectedVariant.id)}>+</button>
                                                        </div>
                                                    ) : (
                                                        <button style={{ padding: '6px 70px', border: '1px solid #0057A0', borderRadius: 6, background: '#fff', color: '#0057A0' }} onClick={() => handleAddClick(product, selectedVariant)} >Add</button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    )}
                </div>
            </>



            <>
                <div className=" mt-3" style={{ margin: '0 auto', padding: "20px 30px", backgroundColor: '#f3f2f2', borderRadius: '20px' }}>
                    {/* Header with Scroll Buttons */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="fw-bold mb-0">MY TRENDING PRODUCTS</h6>
                        <div className="d-flex align-items-center gap-2">
                            <Link to="/category" className="text-decoration-none me-2 text-black">View All</Link>
                            <button className="btn btn-light shadow-sm" onClick={() => scroll('left', trendingRef)}><FaChevronLeft /></button>
                            <button className="btn btn-light shadow-sm" onClick={() => scroll('right', trendingRef)}><FaChevronRight /></button>
                        </div>
                    </div>

                    {/* Product Cards */}
                    {products.length === 0 ? (
                        <div className="text-center text-muted"><p>No products available</p></div>
                    ) : (
                        <div ref={trendingRef} className="d-flex" style={{ gap: '1rem', paddingBottom: '1rem', scrollBehavior: 'smooth', overflowX: 'auto', overflowY: 'hidden', msOverflowStyle: 'none', scrollbarWidth: 'none', }} >
                            {products
                                .filter((product) => {
                                    if (!user) return true;
                                    if (user.businessType === 'B2B') return product.bb;
                                    if (user.businessType === 'B2C') return product.bc;
                                    return true;
                                })
                                .map((product) => {
                                    const selectedIndex = selectedVariants[product.id] ?? 0;
                                    const selectedVariant = product.variants?.[selectedIndex];
                                    const currentQuantity = selectedVariant ? getQuantity(product.id, selectedVariant.id) : 0;
                                    const maxDiscountVariant = product.variants?.reduce((max, variant) => variant.discount > max.discount ? variant : max, product.variants[0]);
                                    const discountedPrice = selectedVariant?.discount
                                        ? Math.round(selectedVariant.price - (selectedVariant.price * selectedVariant.discount) / 100)
                                        : null;


                                    const key = `${product.id}_${selectedVariant?.id}`;
                                    const isWishlisted = wishlist[key];
                                    return (
                                        <div key={product.id} className="border bg-white shadow-sm flex-shrink-0 d-flex flex-column position-relative" style={{ width: '250px', height: '400px', borderRadius: '12px', overflow: 'hidden', }}>
                                            {/* Discount Badge */}
                                            {maxDiscountVariant?.discount > 0 && (
                                                <div className="position-absolute top-0 start-0 m-2 badge" style={{ background: "linear-gradient(180deg, #F8EEDB 0%, #F3DFAF 100%)", fontSize: '0.75rem', color: '#0058A2' }}>
                                                    {maxDiscountVariant.discount}% OFF
                                                </div>
                                            )}

                                            {/* Product Image */}
                                            <div className="mx-3 mt-3 mb-1 p-2" style={{ border: '1px solid #eee', borderRadius: '8px', backgroundColor: '#fff', }}>
                                                <Link to={`/product/${product.id}`}>
                                                    <img src={product.image_1} alt={product.name} className="card-img-top" style={{ height: '140px', width: '100%', objectFit: 'contain', }} />
                                                </Link>
                                            </div>

                                            {/* Card Content */}
                                            <div className="card-body d-flex flex-column px-3 py-1">
                                                <p style={{ fontSize: 11, color: '#000000', marginBottom: 4, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    <ReactCountryFlag
                                                        countryCode={countryCodeMap[product.super_category]}
                                                        svg
                                                        style={{ width: '18px', height: '18px' }}
                                                    />
                                                    {product.super_category}
                                                </p>
                                                <p style={{ fontSize: '11px', color: '#4caf50', marginBottom: "2px" }}>⚡ {product.category}</p>
                                                <p className="text-muted mb-1" style={{ fontSize: '0.8rem', }}>{product.brand}</p>
                                                <h6 className="fw-bold mb-2" style={{ fontSize: '0.95rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{product.name}</h6>

                                                {/* Variant Selection */}
                                                <div className="mb-2" style={{ position: 'relative' }}>
                                                    <div style={{ border: '1px solid #ccc', padding: '4px 6px', backgroundColor: '#fff', cursor: 'pointer', fontSize: '13px', }}
                                                        onClick={() => setSelectedVariants(prev => ({ ...prev, [product.id + '_open']: !prev[product.id + '_open'], }))}>
                                                        {selectedVariant && (
                                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                <div>
                                                                    <strong>{selectedVariant.unit_value} {selectedVariant.unit}</strong>{' '}
                                                                    {selectedVariant.discount > 0 && (
                                                                        <span style={{ color: 'green', fontWeight: 'bold' }}>{selectedVariant.discount}% OFF</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {selectedVariants[product.id + '_open'] && (
                                                        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #ccc', zIndex: 1000, marginTop: '4px', maxHeight: '200px', overflowY: 'auto' }}>
                                                            {product.variants.map((variant, index) => {
                                                                const variantDiscountedPrice = variant.price - (variant.price * variant.discount) / 100;
                                                                return (
                                                                    <div key={index} onClick={() => { setSelectedVariants(prev => ({ ...prev, [product.id]: index, [product.id + '_open']: false })); }}
                                                                        style={{ padding: '8px', borderBottom: '1px solid #eee', backgroundColor: selectedVariants[product.id] === index ? '#f6f6f6' : 'white', cursor: 'pointer', fontSize: '10px' }}>
                                                                        <div>
                                                                            <strong>{variant.unit_value} {variant.unit}</strong>{' '}
                                                                            {variant.discount > 0 && (<span style={{ color: 'green', fontWeight: 'bold' }}>{variant.discount}% OFF</span>)}
                                                                        </div>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '2px' }}>
                                                                            <span style={{ fontWeight: 'bold' }}>₹{Math.round(variantDiscountedPrice)}</span>
                                                                            {variant.discount > 0 && (<span style={{ textDecoration: 'line-through', color: '#999' }}>₹{variant.price}</span>)}
                                                                            <span style={{ fontSize: '10px', backgroundColor: '#e0f7e9', color: '#4caf50', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>⚡ ADD</span>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Price Display */}
                                                <div className="mb-2">
                                                    {selectedVariant ? (
                                                        <>
                                                            {discountedPrice !== null ? (
                                                                <>
                                                                    <span className="fw-bold text-dark">₹{discountedPrice}</span>{' '}
                                                                    <span className="text-muted text-decoration-line-through me-2">₹{selectedVariant.price}</span>
                                                                </>
                                                            ) : (
                                                                <span className="fw-bold">₹{selectedVariant.price}</span>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <span className="fw-bold">₹0</span>
                                                    )}
                                                </div>

                                                {/* Add/Quantity Controls */}
                                                <div className="d-flex align-items-center mt-auto" style={{ gap: '8px' }}>

                                                    <button style={{ border: '1px solid #ccc', background: '#fff', borderRadius: '6px', padding: '8px', fontSize: '16px', cursor: 'pointer' }}
                                                        onClick={() => {
                                                            addToWishlist(product, selectedVariant);
                                                            // alert(`${product.name} saved to wishlist!`);
                                                            alert(
                                                                isWishlisted
                                                                    ? `${product.name} removed from wishlist!`
                                                                    : `${product.name} saved to wishlist!`
                                                            );
                                                        }}>
                                                        {/* <FaRegBookmark style={{color:'black'}}/> */}
                                                        {/* <FaRegBookmark
                                                            style={{
                                                                color: isWishlisted ? 'red' : 'black',       // change icon color when saved
                                                                fill: isWishlisted ? 'red' : 'green'          // fill icon when saved
                                                            }}
                                                        /> */}
                                                        {isWishlisted ? (
                                                            <FcBookmark size={22} />     // filled icon
                                                        ) : (
                                                            <FaRegBookmark size={22} />   // empty icon
                                                        )}
                                                    </button>

                                                    {currentQuantity > 0 ? (
                                                        <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #0057A0', borderRadius: 6, overflow: 'hidden' }}>
                                                            <button style={{ background: '#0057A0', color: '#fff', padding: '6px 30px', border: 'none' }} onClick={() => handleDecrement(product.id, selectedVariant.id)}>−</button>
                                                            <div style={{ padding: '6px 12px', fontSize: 14 }}>
                                                                {currentQuantity}
                                                            </div>
                                                            <button style={{ background: '#0057A0', color: '#fff', padding: '6px 35px', border: 'none' }} onClick={() => handleIncrement(product.id, selectedVariant.id)}>+</button>
                                                        </div>
                                                    ) : (
                                                        <button style={{ padding: '6px 70px', border: '1px solid #0057A0', borderRadius: 6, background: '#fff', color: '#0057A0' }} onClick={() => handleAddClick(product, selectedVariant)} >Add</button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    )}
                </div>
            </>





            <h5 style={{ textAlign: 'center', textTransform: 'uppercase', margin: '16px 0', fontWeight: 'bold' }}>Categories</h5>
            <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                {Array.from(categoriesp.reduce((acc, cat) => {
                    if (!acc.has(cat.super_cat_name)) acc.set(cat.super_cat_name, []);
                    acc.get(cat.super_cat_name).push(cat);
                    return acc;
                }, new Map())
                ).map(([superCatName, catList]) => {
                    const categoriesWithSubcats = catList.filter(category => subcategories.some(sub => sub.category_id === category.id.toString()));
                    if (categoriesWithSubcats.length === 0) return null;
                    return (
                        <div key={superCatName} style={{ marginBottom: '50px' }}>
                            <h4 style={{ textTransform: 'uppercase', color: '#555', marginBottom: '0px' }}>{superCatName}</h4>
                            {categoriesWithSubcats.map(category => {
                                const subcats = subcategories.filter(sub => sub.category_id === category.id.toString());
                                return (
                                    <div key={category.id} style={{ marginBottom: '0px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px 0' }}>
                                            <h6 style={{ color: '#333', textTransform: 'uppercase', margin: 0 }}><strong>{category.name}</strong></h6>
                                            {subcats.length > 4 && (
                                                <Link to={`/categories/${encodeURIComponent(category.name)}`} style={{ textDecoration: 'none', color: '#007bff', fontWeight: '600', fontSize: '14px' }}>
                                                    View More
                                                </Link>
                                            )}
                                        </div>
                                        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)', gap: '30px' }}>
                                            {subcats.slice(0, 4).map(sub => (
                                                <div key={sub.id} style={{ textAlign: 'center' }}>
                                                    <Link to={`/food/${encodeURIComponent(category.name)}/${encodeURIComponent(sub.subCategory)}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                                        <img src={sub.image_sub} alt={sub.subCategory}
                                                         style={{ width: '100%', 
                                                        //  height: '230px',
                                                           height: isMobile ? '150px' : '170px',
                                                          objectFit: 'fill', marginBottom: '12px' }} />
                                                        <p style={{ fontSize: '16px', color: '#333', fontWeight: '600', margin: 0 }}>{sub.subCategory}</p>
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', fontSize: '14px', fontWeight: '600', color: '#000000ff', textDecoration: 'underline', cursor: 'pointer' }}>
                                                            <span>View Collection</span>
                                                            <FaArrowRight size={14} />
                                                        </div>
                                                    </Link>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>










            <Footer />
        </>
    );
};

export default Home;
